import { Environment } from './environment';

export const environment = {
  appVersion: require('package.json').version,
  status: Environment.Uat,
  isSecure: false,
  domain: "documentmanager.uat.abcis.com.au",
  authUrl: "https://auth.uat.abcis.com.au/",
  cloudFunctionUrl: 'https://dm-ocr-cloud-function-584098560186.australia-southeast1.run.app/',
  clientCredentials: 'document-manager-test:KgTQzQ5QbRTZcY2e'
};
